import '../styles/index.scss';
import 'slick-carousel/slick/slick';
import 'bootstrap';
import memo from "./game-memo";
import memo2 from "./game-memo-2";
import puzzle from "./game-puzzle";
import colorGame from "./game-color";
import memoryDetail from "./game-memory-detail";
import whatMissing from "./game-what-missing";
import balloonGame from "./game-balloon";
import sequenceGame from "./game-sequence";
import matchGame from "./game-match";
import reverseMemo from "./game-reverse-memo";
import motionMemo from "./game-motion-memo";
import mazeGame from "./game-maze";
import functions from "./functions";

class Main {
    constructor() {
        this.onDOMLoaded();
        this.onDocumentLoad();
        this.onResize();
        this.onScroll();
        window.jQuery = window.$ = $;
    }

    onDocumentLoad() {
        window.addEventListener("load", (event) => {

        });
    }

    onDOMLoaded() {
        document.addEventListener("DOMContentLoaded", (event) => {
            if ($('body').hasClass('single-memo')) {
                memo.initGame();
            }
            if ($('body').hasClass('single-memo-2')) {
                memo2.initGame();
            }
            if ($('body').hasClass('single-color-game')) {
                colorGame.initGame();
            }
            if ($('body').hasClass('single-memory-detail')) {
                memoryDetail.initGame();
            }
            if ($('body').hasClass('single-what-missing')) {
                whatMissing.initGame();
            }
            if ($('body').hasClass('single-balloon-game')) {
                balloonGame.initGame();
            }
            if ($('body').hasClass('single-sequence-game')) {
                sequenceGame.initGame();
            }
            if ($('body').hasClass('single-match-game')) {
                matchGame.initGame();
            }
            if ($('body').hasClass('single-reverse-memo')) {
                reverseMemo.initGame();
            }
            if ($('body').hasClass('single-motion-memo')) {
                motionMemo.initGame();
            }
            if ($('body').hasClass('single-maze-game')) {
                mazeGame.initGame();
            }
            puzzle.initGame();
            functions.iframeResponsive();

        });
    }

    onResize() {
        window.addEventListener('resize', (event) => {

        });
    }

    onScroll() {
        window.addEventListener('scroll', (event) => {

        });
    }
}

new Main();





// WEBPACK FOOTER //
// ./src/scripts/index.js